var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge flex"},[_c('div',{class:[
            _vm.badgeClass,
            'flex items-center gap-1 rounded-full px-2 py-1.5 text-xs ring-1 ring-inset',
        ]},[(_vm.icon)?_c('Icon',{staticClass:"h-3 w-3 flex-none fill-error-dark stroke-white",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._t("default"),_c('span',{staticClass:"text-xs font-medium leading-none"},[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.loading)?_c('span',{staticClass:"-ml-0.5"},_vm._l((3),function(x){return _c('span',{key:x,staticClass:"load_dot"},[_vm._v(".")])}),0):_vm._e()])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }